module.exports = __webpack_public_path__ + "static/media/projects-text-ru.2f683804.svg";